import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { Template } from '../models';
import { TemplateActions } from '../actions';

export interface State extends EntityState<Template> {}

export const adapter: EntityAdapter<Template> = createEntityAdapter<Template>({
  selectId: (a) => a.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

export const initialState: State = adapter.getInitialState();

export const reducer = createReducer(
  initialState,

  on(TemplateActions.fetchRequest, (state) => adapter.removeAll(state)),

  on(TemplateActions.fetchSuccess, (state, { templates }) =>
    adapter.addMany(templates, state),
  ),
);
